import { DataVizContainerViewConfigWithoutStateManager } from '../../../common/types';
import {
  KpiFactboxSingleMetricVizData,
  KpiFactboxSingleMetricVizExternalProps,
} from '../../types';
import { singleColumnFactboxDataToUiComponentProps } from './dataToUiComponentProps';
import { KpiSingleColumnUiComponentProps } from './types';
import { KpiSingleColumnUiComponent } from './UiComponent';

export const singleColumnFactboxViewConfig: DataVizContainerViewConfigWithoutStateManager<
  KpiFactboxSingleMetricVizData,
  KpiFactboxSingleMetricVizExternalProps,
  KpiSingleColumnUiComponentProps
> = {
  hasStateManager: false,
  dataToUiComponentProps: singleColumnFactboxDataToUiComponentProps,
  UiComponent: KpiSingleColumnUiComponent,
};
